import { render, staticRenderFns } from "./SpeakersSlider.vue?vue&type=template&id=cadace26&lang=pug"
import script from "./SpeakersSlider.vue?vue&type=script&lang=js"
export * from "./SpeakersSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports